<template>
  <v-dialog v-model="dialog" width="500" :disabled="getRole()">
    <template v-slot:activator="{ on, attrs }">
      <v-btn block :color="getRole() == true ? 'grey' : buttonColor" dark v-bind="attrs" v-on="on" elevation="12">
        {{ cardTitle }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ cardTitle }}
      </v-card-title>
      <v-card-text>
        {{ cardText }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="sendCommand()">
          {{ actionYes }}
        </v-btn>
        <v-btn color="primary" text @click="dialog = false">
          {{ actionNo }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

import { ServiceClient } from "../../service_client/index.js";

export default {
  name: "DialogCommandDialog",
  props: {
    command: {
      type: String,
      default: "",
      required: true,
    },
    type: {
      type: String,
      default: "parameters",
      required: false,
    },
    buttonColor: {
      type: String,
      default: "red lighten-2",
      required: false,
    },
    cardTitle: {
      type: String,
      default: "cardTitle",
      required: false,
    },
    cardText: {
      type: String,
      default: "cardText",
      required: false,
    },
    actionYes: {
      type: String,
      default: "actionYes",
      required: false,
    },
    actionNo: {
      type: String,
      default: "actionNo",
      required: false,
    },
  },
  components: {},
  data() {
    return {
      dialog: false,

      user: JSON.parse(sessionStorage.getItem("user")),
    };
  },
  created() {},
  mounted() {},
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  methods: {
    getRole() {
      if (this.account.user.roles[0] != "EC_ADMIN") {
        return true;
      } else {
        return false;
      }
    },
    sendCommand() {
      this.dialog = false;

      let parameters = "?cmd=" + this.command;

      ServiceClient.dataCore(ServiceClient.getAPIUrl(this.type), null, parameters, "GET").catch((error) => {
        ServiceClient.handleUnauthorized(error, this.$router);
      });
    },
  },
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style scoped></style>
